import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import { SvgAsset } from '@ingenico/react-ui/svg-asset';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import type { LogicalDeviceConnectivityInfoParams } from './logicalDeviceConnectivityInfo.model';
import { LogicalDeviceConnectivityIconColor } from './logicalDeviceConnectivityInfo.model';
import styles from './logicalDeviceConnectivityInfo.module.scss';

export function LogicalDeviceConnectivityInfo({
  icon,
  label,
  iconColor = LogicalDeviceConnectivityIconColor.Inherit,
  tooltip,
  containerClassName,
  subtitle,
}: LogicalDeviceConnectivityInfoParams): ReactNode {
  return (
    <div className={classNames(styles.container, containerClassName ?? '')}>
      <SvgAsset
        className={classNames({
          [styles.iconSuccess]: iconColor === LogicalDeviceConnectivityIconColor.Succes,
          [styles.iconInherit]: iconColor === LogicalDeviceConnectivityIconColor.Inherit,
          [styles.iconWarning]: iconColor === LogicalDeviceConnectivityIconColor.Mid,
          [styles.iconError]: iconColor === LogicalDeviceConnectivityIconColor.Low,
        })}
        image={icon}
      />
      <div className={styles.textContainer}>
        <CoreTypography
          showTooltip={!!tooltip}
          tooltipTitle={tooltip ?? label}
          truncateText
          variant={CoreTypographyVariant.Body01Medium}
        >
          {label}
        </CoreTypography>
        <CoreTypography
          customClassName={styles.subtitle}
          showTooltip={!!tooltip}
          tooltipTitle={tooltip ?? subtitle}
          truncateText
          variant={CoreTypographyVariant.Body03Regular}
        >
          {subtitle}
        </CoreTypography>
      </div>
    </div>
  );
}
